export const AvailableLang = {
  Undefined: '',
  JP: 'JP',
  KR: 'KR',
  TW: 'TW',
  HK: 'HK',
  EN: 'EN',
  VN: 'VN',
  CN: 'CN',
} as const
export type Lang = typeof AvailableLang[keyof typeof AvailableLang]
